import {FC} from 'react'
import clsx from 'clsx'

type Props = {
  min: number
  max: number
  value: number
  height?: number
  showValue?: boolean
  className?:{
    progress: string
    bar?: string
  }
}

const ProgressBar: FC<Props> = ({min, max, value, height, className, showValue}) => {
  const prc = value * 100 / max
  return (
    <div
      className={clsx('progress', className?.progress)}
      style={{height: `${height ?? 10}px`, position: 'relative'}}
    >
      <div
        className={clsx('progress-bar', className?.bar)}
        role="progressbar"
        style={{width: `${prc}%`}}
        aria-valuenow={value}
        aria-valuemin={min}
        aria-valuemax={max}
      >
        {showValue === true && (
          <strong
            style={{ position: 'absolute', width: '100%' }}
          >
            {value} / {max}
          </strong>
        )}
      </div>
    </div>
  )
}

export default ProgressBar
